export default function extractSupportQuery(ruleSet) {
  return ruleSet.split('{')[0].slice(9).trim();
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-dom/es/dom/rehydration/extractSupportQuery.js
// module id = 862
// module chunks = 1